import styles from "@/assets/scss/LottieLoading.module.scss";
import { useEffect } from "react";

const LottieLoading = () => {
  useEffect(() => {
    let animation: any;
    if (window.lottie && window.lottie.loadAnimation) {
      animation = window.lottie.loadAnimation({
        container: document.getElementById("lottie_element"), // Required
        path: "/lottieLoading.json", // Required
        renderer: "svg", // Required
        loop: true, // Optional
        autoplay: true, // Optional
        name: "PayPing Dot", // Name for future reference. Optional.
      });
    }
    return () => {
      if (animation?.destroy) animation.destroy();
    };
  }, []);

  return (
    <div className={styles.lottie} id="lottie_container">
      <div className={styles.animation} id="lottie_element"></div>
    </div>
  );
};

export default LottieLoading;
